export default "__VITE_ASSET__a599e8da__"